import { appHistory } from 'appHistory';
import { logoutURL } from 'util/AppConfig.jsx';

export function menuLink(item) {
/*   if (item.key === 'home') {
    appHistory.push('/');
  } */
  console.warn('selezione del menu item:', item);
  switch(item.key) {
    case 'logout':
      window.location.href = logoutURL;
      break;
    case 'faq':
      window.location.href = 'https://apps.unimi.it/web/registri/docenti/faq.pdf';
      break;
    case 'home':
      appHistory.push('/');
      break;
    default:
      break;
  }
}

export function registryLink(record) {
  console.log('che mi arriva da rowClick:', record);
  appHistory.push(`registro/${record.idRegistro.toString()}`);
}

export function trasversalLink(record) {
  appHistory.push(`attivita/${record.idRegistro.toString()}`);
}